import { motion } from 'framer-motion';
import { useState } from 'react';
import { Send, Facebook, Instagram, Linkedin, Youtube } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    // Newsletter signup - would connect to FluentForm or email service
    console.log('Newsletter signup:', email);
    setEmail('');
  };

  const socialLinks = [
    {
      icon: Facebook,
      href: 'https://www.facebook.com/Gdelieuze/',
      label: 'Facebook',
    },
    {
      icon: Instagram,
      href: 'https://www.instagram.com/gilles_delieuze/',
      label: 'Instagram',
    },
    {
      icon: Linkedin,
      href: 'https://www.linkedin.com/in/gilles-delieuze-830544a2/',
      label: 'LinkedIn',
    },
    {
      icon: Youtube,
      href: 'https://www.youtube.com/channel/UCzJ61lnyiUJmZJwuoH7jlEA',
      label: 'YouTube',
    },
  ];

  const quickLinks = [
    { label: 'Accueil', href: '#hero' },
    { label: 'À propos', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Témoignages', href: '#testimonials' },
    { label: 'Contact', href: 'https://devgilles.wptotem.com/contact/' },
  ];

  const legalLinks = [
    { label: 'Mentions légales', href: 'https://devgilles.wptotem.com/mentions-legales' },
    {
      label: 'Politique de confidentialité',
      href: 'https://devgilles.wptotem.com/politique-de-confidentialite/',
    },
    {
      label: 'CGV',
      href: 'https://devgilles.wptotem.com/conditions-de-generales-vente/',
    },
  ];

  return (
    <footer data-testid="footer" className="relative bg-[#1C1917] pt-20 pb-8">
      {/* Top Gold Line */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent" />

      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Newsletter Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h3 className="font-display text-2xl md:text-3xl text-[#FAFAF9] mb-4">
            Restons <span className="italic text-[#D4AF37]">connectés</span>
          </h3>
          <p className="text-[#A8A29E] mb-8 max-w-md mx-auto">
            Recevez mes articles, pépites et bonus hebdomadaires pour vous
            accompagner sur votre chemin.
          </p>
          <form
            onSubmit={handleSubmit}
            className="flex flex-col sm:flex-row gap-4 max-w-md mx-auto"
            data-testid="newsletter-form"
          >
            <input
              type="email"
              placeholder="Votre adresse e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-grow bg-transparent border border-[#D4AF37]/30 rounded-full px-6 py-4 text-[#FAFAF9] placeholder:text-[#A8A29E] focus:border-[#D4AF37] outline-none transition-colors"
              data-testid="newsletter-input"
            />
            <button
              type="submit"
              data-testid="newsletter-submit"
              className="bg-gradient-to-r from-[#D4AF37] to-[#AA8C2C] text-white rounded-full px-8 py-4 uppercase tracking-widest text-sm font-bold hover:shadow-[0_0_20px_rgba(212,175,55,0.4)] transition-all duration-300 flex items-center justify-center gap-2"
            >
              S'inscrire
              <Send size={16} />
            </button>
          </form>
        </motion.div>

        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-12 pb-12 border-b border-[#D4AF37]/10">
          {/* Brand */}
          <div className="md:col-span-1">
            <img
              src="https://devgilles.wptotem.com/wp-content/uploads/2022/12/Logo_Final_3bd-.png"
              alt="Gilles Delieuze"
              className="h-16 w-auto mb-6"
            />
            <p className="text-[#A8A29E] text-sm leading-relaxed">
              Expansion de conscience et alchimie intérieure. Libérez votre potentiel
              illimité.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#D4AF37] uppercase tracking-widest text-sm font-medium mb-6">
              Navigation
            </h4>
            <ul className="space-y-3">
              {quickLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-[#A8A29E] hover:text-[#FAFAF9] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-[#D4AF37] uppercase tracking-widest text-sm font-medium mb-6">
              Légalité
            </h4>
            <ul className="space-y-3">
              {legalLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-[#A8A29E] hover:text-[#FAFAF9] transition-colors text-sm"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#D4AF37] uppercase tracking-widest text-sm font-medium mb-6">
              Contact
            </h4>
            <address className="text-[#A8A29E] text-sm not-italic leading-relaxed">
              Delieuze Gilles
              <br />
              Espace Asanoha
              <br />
              7 Rue de l'Église
              <br />
              11200 Ornaisons
            </address>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="pt-8 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-[#A8A29E] text-sm">
            © 2016-2033 Gilles Delieuze. Tous droits réservés.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={social.label}
                className="w-10 h-10 rounded-full border border-[#D4AF37]/30 flex items-center justify-center text-[#D4AF37] hover:bg-[#D4AF37] hover:text-white transition-all duration-300"
                data-testid={`social-${social.label.toLowerCase()}`}
              >
                <social.icon size={18} strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
